import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputError from '../../../errors/InputError';
import './RadioInputList.css';

export default class RadioInputList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedId: (this.props.selectedId) ? this.props.selectedId : null
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if ('selectedId' in newProps && newProps.selectedId !== undefined && newProps.selectedId !== this.state.selectedId) {
      this.setState({ selectedId: newProps.selectedId });
    }
  }

  onChange = (radioId, e) => {
    this.setState({ selectedId: radioId });
    if (this.props.onChange) {
      this.props.onChange(e, radioId);
    }
  }

  getValue = () => {
    if (this.props.required && this.state.selectedId === null) {
      throw new InputError(this.props.legend + " is Required", this.state.selectedId);
    }

    return this.state.selectedId;
  }

  render() {
    const requiredFieldIndicator = (this.props.required && this.props.isEditable)
      ? <abbr title="This field is required"></abbr>
      : null;

    let errorMessage = (this.props.errorMessage)
      ? <span className="error-message">
        {this.props.errorMessage}
      </span>
      : null;

    let legend = (this.props.legend || this.props.required)
      ? <legend>{this.props.legend}{requiredFieldIndicator}</legend>
      : null;

    let helperText = this.props.helperText ?
      <span className="helper-text">
        {this.props.helperText}
      </span> :
      null;

    let verticalSpacingClass = this.props.verticalSpacing === "compact" ? "field--compact" : "field";

    const radioButtons = this.props.radioProps.map((radioProp, index) => {

      let radio = (
        <input
          id={radioProp.id}
          className={radioProp.className}
          type="radio"
          name={this.props.groupName}
          value={radioProp.value}
          required={this.props.required}
          checked={(radioProp.checked) ? radioProp.checked : this.state.selectedId === radioProp.id}
          onChange={(e) => this.onChange(radioProp.id, e)}
        />
      );

      let label = (<label htmlFor={radioProp.id}>{radioProp.label}</label>);

      const radioWrapperClassNames = "radio-button " + this.props.radioWrapperClassName;

      return (
        <div key={radioProp.id} className={radioWrapperClassNames}>{radio}{label}</div>
      );
    })

    let checkedRadio = (this.state.selectedId) ?
      this.props.radioProps.find((radioProp) => (radioProp.id === this.state.selectedId)) :
      this.props.radioProps.find((radioProp) => (radioProp.checked));

    let checkedRadioLabel = (checkedRadio) ? checkedRadio.label : null;

    let radioInputContent = (this.props.isEditable) ?
      <span className="radio-input-list">
        <fieldset id={this.props.id} disabled={this.props.disabled} className={'field__group radio-input-list__fieldset ' + this.props.className}>
          <legend>{this.props.legend}{requiredFieldIndicator}</legend>
          {radioButtons}
        </fieldset>
        {errorMessage}
        {helperText}
      </span> :
      <span>
        <legend>{this.props.legend}{requiredFieldIndicator}</legend>
        <div className="read-only">
          {checkedRadioLabel}
        </div>
      </span>;

    return (
      <div heap-ignore='true' className={verticalSpacingClass}>
        {radioInputContent}
      </div>
    );
  }
}

RadioInputList.defaultProps = {
  isEditable: true,
  radioWrapperClassName: ""
};

RadioInputList.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  groupName: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  id: PropTypes.string.isRequired,
  isEditable: PropTypes.bool,
  legend: PropTypes.string,
  onChange: PropTypes.func,
  radioProps: PropTypes.arrayOf(PropTypes.shape({
    checked: PropTypes.bool,
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired,
  radioWrapperClassName: PropTypes.string,
  required: PropTypes.bool,
  selectedId: PropTypes.string,
  verticalSpacing: PropTypes.string
}
